import React, { memo } from 'react';
import { Diamond } from '@saleshandy/icons';
import { accessibleOnClick } from '../../utils/accessible-on-click';
import './credits-indicator.scss';

interface IProps {
  credits: number;
  onClick?: () => void;
  label?: string;
  abbreviated?: boolean;
}

const CreditsIndicator: React.FC<IProps> = memo(
  ({ credits, onClick, label = 'Credits', abbreviated = false }) => {
    const formatCredits = (num: number, abbrev: boolean) => {
      if (!abbrev) return num.toLocaleString();

      if (num >= 1000000) {
        return `${(num / 1000000).toFixed(1).replace('.0', '')}M`;
      }
      if (num >= 1000) {
        return `${(num / 1000).toFixed(1).replace('.0', '')}k`;
      }
      return num.toString();
    };

    return (
      <div className="credits-indicator">
        <span {...(onClick ? accessibleOnClick(onClick) : {})}>
          <Diamond width={16} height={16} className="credits-indicator__icon" />
          <span className="credits-indicator__text">{`${formatCredits(
            credits,
            abbreviated,
          )} ${label}`}</span>
        </span>
      </div>
    );
  },
);

CreditsIndicator.displayName = 'CreditsIndicator';

export default CreditsIndicator;
